/** "5 minutes ago", "yesterday", "3 Oct" — short relative times for the bell, in the UI language. */

const UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ["minute", 60],
  ["hour", 60 * 60],
  ["day", 60 * 60 * 24],
];

export function timeAgo(iso: string, locale: string, now: Date = new Date()): string {
  const date = new Date(iso);
  const seconds = Math.round((date.getTime() - now.getTime()) / 1000); // negative = past
  const past = -seconds;
  const format = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
  if (past < 60) return format.format(0, "second"); // "now"
  if (past < 60 * 60) return format.format(Math.round(seconds / UNITS[0]![1]), "minute");
  if (past < 60 * 60 * 24) return format.format(Math.round(seconds / UNITS[1]![1]), "hour");
  if (past < 60 * 60 * 24 * 7) return format.format(Math.round(seconds / UNITS[2]![1]), "day");
  return new Intl.DateTimeFormat(locale, {
    day: "numeric",
    month: "short",
    ...(date.getFullYear() === now.getFullYear() ? {} : { year: "numeric" }),
  }).format(date);
}
